<template>
    <component :is="wrapperComponent" v-bind="wrapperProps">
        <div class="mb-4">
            <h3 class="text-base font-semibold text-gray-900 dark:text-txt-headings">{{ title }}</h3>
            <p v-if="description" class="mt-1 text-sm text-gray-700 dark:text-txt-body">{{ description }}</p>
        </div>

        <div class="space-y-4">
            <div v-for="(item, index) in items" :key="`${item.title}-${index}`" class="flex gap-3">
                <span class="mt-0.5 shrink-0 text-xl">{{ item.icon }}</span>
                <div>
                    <h4 class="text-sm font-semibold text-gray-900 dark:text-txt-headings">{{ item.title }}</h4>
                    <p class="mt-1 text-sm text-gray-700 dark:text-txt-body">{{ item.description }}</p>
                </div>
            </div>
        </div>
    </component>
</template>

<script setup lang="ts">
import type { OnboardingTip } from '@/components/onboarding/OnboardingTips.vue'
import CAlert from '@/components/ui/CAlert.vue'

defineOptions({
    inheritAttrs: false
})

const attrs = useAttrs()

const props = withDefaults(
    defineProps<{
        title: string
        description?: string
        items: OnboardingTip[]
        variant?: 'default' | 'success'
    }>(),
    {
        description: undefined,
        variant: 'default'
    }
)

const wrapperComponent = computed(() => (props.variant === 'success' ? CAlert : 'section'))

const wrapperProps = computed(() => {
    if (props.variant === 'success') {
        return {
            class: ['text-left', attrs.class],
            variant: 'success'
        }
    }

    return {
        class: ['rounded-md border border-primary-150 bg-primary-50 dark:bg-primary-950/40 p-4 text-left', attrs.class]
    }
})
</script>
